<template>
  <div>
    <vs-card>
      <div :key="index" v-for="(value, index) in copyCount">
        <div class="flex" style="display: flex" :style="[index % 5 == 0 || index == 0 ? { pageBreakBefore: 'always', marginTop: '45px' } : {}]">
          <div class="parent">
            <div class="left-side">
              <b>Product Name : </b>{{ (product && product.productLabel && product.productLabel.product_name) || (product && product.product_name) }}
              <br />
              <b>Serial Number : </b>{{ (product && product.productLabel && product.productLabel.serialNumber) || '' }}
              <br />
              <b>Batch Number : </b>{{ (product && product.productLabel && product.productLabel.batchNumber) || '' }}
              <br />
              <b>Date Packaged : </b>{{ product | packagedDate }}
              <br />
              <b>Expiry Date : </b>{{ product | expiryDate }}
              <br />
              <b>CBD (% ): </b>{{ (product && product.productLabel && product.productLabel.cbd) || '' }}
              <br />
              <b>THC (% ): </b>{{ (product && product.productLabel && product.productLabel.thc) || '' }}
              <br />
              <b>License Number: </b>{{ supplier && supplier.omma_license_number }}
              <br />
              <b>Business Name : </b>{{ (supplier && supplier.business_name) || (supplier && supplier.username) }}
              <br />
              <b>Business Address : </b>{{ (product && product.productLabel && product.productLabel.businessAddress) || '' }}
              <br />
              <b>Qty/Weight of Conents: </b>{{ (product && product.productLabel && product.productLabel.quantity_Or_weightOfContents) || '' }}
              <br />
              <b>Ingredients List : </b>{{ (product && product.productLabel && product.productLabel.ingredientList) || '' }}
              <br />
              <b>Food Allergen Info: </b>{{ (product && product.productLabel && product.productLabel.foodAllergenInfo) || '' }}
              <br />
              <b>Nutrition Info : </b>{{ (product && product.productLabel && product.productLabel.nutritionInformation) || '' }}
              <br />
              <b>Cannabis Ingredients : </b>{{ (product && product.productLabel && product.productLabel.cannabisIngredients) || '' }}
              <br />
              <b>THC Dosage /Unit(Mg): </b>{{ (product && product.productLabel && product.productLabel.THC_Dosage) || '' }}
              <br />
              <b>Lot Code : </b>{{ (product && product.productLabel && product.productLabel.lotCode) || '' }}
              <br />
              <b>Terponeid Potency : </b>{{ (product && product.productLabel && product.productLabel.terpenoidPotency) || '' }}
              <br />
              <b>Caution: </b> Women should not use marijuana or medical marijuana during pregnancy because of the risk of health defects or while breastfeeding. Keep out of reach of children. For
              accidental ingestion call 1-800-222-1222 <br />
              <b>NB: </b> This product has been tested for contaminants <br />
            </div>
            <div class="right-side">
              <img src="@/assets/images/product_label/label.png" class="logo" style="width: 100px" />
              <!-- <bar-code :options="options" :value="product.productLabel && product.productLabel.batchNumber" /> -->
            </div>
          </div>

          <div class="parent">
            <div class="left-side" v-if="(index + 1 === copyCount.length && totalLabel % 2 === 0) || index + 1 !== copyCount.length">
              <b>Product Name : </b>{{ (product && product.productLabel && product.productLabel.product_name) || (product && product.product_name) }}
              <br />
              <b>Serial Number : </b>{{ (product && product.productLabel && product.productLabel.serialNumber) || '' }}
              <br />
              <b>Batch Number : </b>{{ (product && product.productLabel && product.productLabel.batchNumber) || '' }}
              <br />
              <b>Date Packaged : </b>{{ product | packagedDate }}
              <br />
              <b>Expiry Date : </b>{{ product | expiryDate }}
              <br />
              <b>CBD (% ): </b>{{ (product && product.productLabel && product.productLabel.cbd) || '' }}
              <br />
              <b>THC (% ): </b>{{ (product && product.productLabel && product.productLabel.thc) || '' }}
              <br />
              <b>License Number: </b>{{ supplier && supplier.omma_license_number }}
              <br />
              <b>Business Name : </b>{{ (supplier && supplier.business_name) || (supplier && supplier.username) }}
              <br />
              <b>Business Address : </b>{{ (product && product.productLabel && product.productLabel.businessAddress) || '' }}
              <br />
              <b>Qty/Weight of Conents: </b>{{ (product && product.productLabel && product.productLabel.quantity_Or_weightOfContents) || '' }}
              <br />
              <b>Ingredients List : </b>{{ (product && product.productLabel && product.productLabel.ingredientList) || '' }}
              <br />
              <b>Food Allergen Info: </b>{{ (product && product.productLabel && product.productLabel.foodAllergenInfo) || '' }}
              <br />
              <b>Nutrition Info : </b>{{ (product && product.productLabel && product.productLabel.nutritionInformation) || '' }}
              <br />
              <b>Cannabis Ingredients : </b>{{ (product && product.productLabel && product.productLabel.cannabisIngredients) || '' }}
              <br />
              <b>THC Dosage /Unit(Mg): </b>{{ (product && product.productLabel && product.productLabel.THC_Dosage) || '' }}
              <br />
              <b>Lot Code : </b>{{ (product && product.productLabel && product.productLabel.lotCode) || '' }}
              <br />
              <b>Terponeid Potency : </b>{{ (product && product.productLabel && product.productLabel.terpenoidPotency) || '' }}
              <br />
              <b>Caution: </b> Women should not use marijuana or medical marijuana during pregnancy because of the risk of health defects or while breastfeeding. Keep out of reach of children. For
              accidental ingestion call 1-800-222-1222 <br />
              <b>NB: </b> This product has been tested for contaminants <br />
            </div>
            <div class="right-side" v-if="(index + 1 === copyCount.length && totalLabel % 2 === 0) || index + 1 !== copyCount.length">
              <img src="@/assets/images/product_label/label.png" class="logo" style="width: 100px" height="200px" />
              <!-- <bar-code :options="options" :value="product.productLabel && product.productLabel.batchNumber" /> -->
            </div>
          </div>
        </div>
      </div>
    </vs-card>
    <div v-html="html" />
  </div>
</template>
<script>
import moment from 'moment'
import BarCode from '@/components/utils/BarCode.vue'

export default {
  name: 'LabelSizeFourXTwo',
  components: {
    BarCode
  },
  props: ['product', 'totalLabel', 'supplier'],
  data: () => ({
    options: {
      width: 1,
      height: 40,
      displayValue: false
    },
    html: `
      <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">
      <link href="https://fonts.googleapis.com/css?family=Libre+Barcode+39&display=swap" rel="stylesheet">
      <style>
        // .bg-grid-color-secondary{
        //   padding:5px 25px 5px 5px !important;
        // }

        // .bg-grid-color{
        //   padding:5px 25px 5px 5px !important;
        // }

        .parent {
            height: 175px !important;
            width: 445px !important;
            // margin-top: 55px;
            // margin-left: 30px;
            padding: 10px;
            // background: #ddd;
            display: flex;
            // margin-bottom: -66px;
            // margin-right: 4px;
        }

        /*img{height: 228px !important;width: 445px !important;margin-top: 63px;margin-left: 30px;}*/

        /*right side*/
        .right-side {
            text-align: center;
            width: 23%;
            float: left;
            padding: 5px;
            padding-right: 10px;
        }

        .logo {
            width: 145px;
            height: 150px;
            display: block;
            margin: auto;
            margin-bottom: 4px;
            // margin-left: -38px;
        }

        .barcode {
            height: 37px;
            width: 100%;
            margin-bottom: 5px;
        }

        .right-side h6 {
            font-size: 5px;
            font-weight: bold;
        }

        /*left side*/
        .left-side {
            float: left;
            width: 77%;
            font-size: 6.6px;
            padding-left: 10px;
        }

        .second-page {
            min-height: 1284px !important;
            height: 1284px !important;
            max-height: 1284px !important;
        }
      </style>`
  }),
  mounted() {},
  computed: {
    copyCount() {
      return Array(Number(parseFloat(this.totalLabel / 2).toFixed(0))).fill(null)
    }
  },
  filters: {
    packagedDate(product) {
      if (product && product.productLabel && product.productLabel.packagedDate) {
        return moment(product && product.productLabel && product.productLabel.packagedDate).format('MM-DD-YYYY')
      }
      return ''
    },
    expiryDate(product) {
      if (product && product.productLabel && product.productLabel.expiryDate) {
        return moment(product && product.productLabel && product.productLabel.expiryDate).format('MM-DD-YYYY')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped></style>
